import React, { memo, useContext } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { AppContext } from '@prisjakt/ui-app-context';
import T from '@prisjakt/ui-translate';

import * as S from './styles';

const RecommendedRetailer = memo(({ name, logo, pathName, id }) => {
  const { linkTo } = useContext(AppContext);
  return (
    <S.RecommendedRetailerExpansion>
      <Link to={linkTo('brand', { pathName, id })}>
        {logo ? <img src={logo} alt={name} /> : null}
        <T domain="store">brand.recommended-retailer</T>
      </Link>
    </S.RecommendedRetailerExpansion>
  );
});

const { string } = PropTypes;

RecommendedRetailer.propTypes = {
  name: string,
  logo: string,
  pathName: string,
  id: string,
};

RecommendedRetailer.defaultProps = {
  name: '',
  logo: undefined,
  pathName: undefined,
  id: undefined,
};

export default RecommendedRetailer;
